/**
 * activeBrand — the house brand baked into THIS build (client-only).
 *
 * `import.meta.env.VITE_BRAND` is injected by `vite.config.ts` (`define`), so
 * this resolves deterministically at build time. Kept out of `brands/index.ts`
 * so the registry stays environment-agnostic and importable by the Vite config
 * (Node), where `import.meta.env` is not available.
 */
import type { BrandConfig } from './types';
import { resolveBrand } from './index';

export const activeBrand: BrandConfig = resolveBrand(
  import.meta.env?.VITE_BRAND
);

/**
 * activeTenantId — the tenant baked into THIS build, or null when the build is
 * brand-only and must resolve its tenant from the hostname.
 *
 * `vite.config.ts` already folds `VITE_TENANT_ID` down to the brand's own
 * `tenantId`, so the `??` here is only the belt-and-braces path for consumers
 * (e.g. vitest) that import this module without the Vite `define` applied.
 */
export const activeTenantId: string | null =
  import.meta.env?.VITE_TENANT_ID || activeBrand.tenantId || null;
